import { DateConverter } from '../../../core/services/mapper/converters';
import * as moment from 'moment/moment';
import { DataIdArrayConverterFactory } from '../../../core/services/mapper/data-id.converter';
import { Operateur } from '../../intervenant/models/operateur.model';
import { College } from './college.model';

export class ComQualif {
    static jsonMap = {
        id: 'id',
        idJure: 'idJure',
        dateFormationDer: { key: 'dateFormationDer', converter: new DateConverter() },
        dateFormationInit: { key: 'dateFormationInit', converter: new DateConverter() },
        dateFin: { key: 'dateFin', converter: new DateConverter() },
        idCahier: 'idCahier',
        idsOperateurs: { key: 'idIntervenants', default: () => [] },
        colleges: { key: 'idRefColleges', converter: new (DataIdArrayConverterFactory.build(College, 'colleges'))(), default: () => [] }
    };

    id: number;
    idJure: number;
    dateFormationDer: moment.Moment;
    dateFormationInit: moment.Moment;
    dateFin: moment.Moment;
    idCahier: number;
    idsOperateurs: number[];
    colleges: College[] = [];

    operateurs: Operateur[] = [];
}
